var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerDiv"},[_vm._v(" Copyright © 1999-2021 | 上海煜豆软件技术有限公司 | 京ICP备021-8888888888888888号 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }